"use client";

import SiteNav from "@/components/SiteNav";
import NotFound from "@/components/pages/NotFound";

export default function NotFoundPage() {
  return (
    <>
      <SiteNav />
      <NotFound />
    </>
  );
}
